import React from 'react';
import WMICHOCustomCoverageTermDetailView from '../../WMICHOCustomCoverageTerm/WMICHOCustomCoverageTermDetailView/WMICHOCustomCoverageTermDetailView';
import metadata from './WMICHODesignatedPremisesLiabilityCovDetailView.metadata.json5';

function WMICHODesignatedPremisesLiabilityCovDetailView(props) {
    const { id, itemVM, onSaveItem, onCancelItem, onValidate: parentOnValidate, showErrors: parentShowErrors } = props;

    return (
        <WMICHOCustomCoverageTermDetailView
            id={id}
            itemVM={itemVM}
            onSaveItem={onSaveItem}
            onCancelItem={onCancelItem}
            onValidate={parentOnValidate}
            showErrors={parentShowErrors}
            content={metadata.componentContent}
        />
    );
}

export default WMICHODesignatedPremisesLiabilityCovDetailView;
